// === Navbar ===
const navbar = document.getElementById('navbar');
if (navbar) {
  window.addEventListener('scroll', () => navbar.classList.toggle('nav-scrolled', window.scrollY > 80), { passive: true });
}

// === Mobile Menu ===
const menuToggle = document.getElementById('menuToggle');
const mobileMenu = document.getElementById('mobileMenu');
const menuLine1 = document.getElementById('menuLine1');
const menuLine2 = document.getElementById('menuLine2');
let menuOpen = false;

function closeMobile() {
  menuOpen = false; 
  if(mobileMenu) mobileMenu.classList.remove('open');
  if(menuLine1) menuLine1.style.transform = ''; 
  if(menuLine2) {
    menuLine2.style.transform = ''; 
    menuLine2.style.width = '';
  }
  document.body.style.overflow = '';
}

if (menuToggle) {
  menuToggle.addEventListener('click', () => {
    menuOpen = !menuOpen;
    mobileMenu.classList.toggle('open', menuOpen);
    if (menuOpen) {
      menuLine1.style.transform = 'rotate(45deg) translateY(4px)';
      menuLine2.style.transform = 'rotate(-45deg) translateY(-3px)';
      menuLine2.style.width = '24px';
      document.body.style.overflow = 'hidden';
    } else { closeMobile(); }
  });
}
document.querySelectorAll('.mobile-link').forEach(l => l.addEventListener('click', closeMobile));

// === Scroll Reveal ===
const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(e => { 
    if (e.isIntersecting) { 
      e.target.classList.add('visible'); 
      revealObserver.unobserve(e.target); 
    } 
  });
}, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

function reObserveReveals() {
  document.querySelectorAll('.reveal:not(.visible)').forEach(el => revealObserver.observe(el));
}
reObserveReveals();

// === Gallery Carousels (Slick Marquee) ===
jQuery(function($) {
  if ($('.gal-slick-1').length) {
    $('.gal-slick-1').slick({
      infinite: true,
      slidesToShow: 1,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
    });
  }
  if ($('.gal-slick-2').length) {
    $('.gal-slick-2').slick({
      infinite: true,
      slidesToShow: 1,
      variableWidth: true,
      autoplay: true,
      autoplaySpeed: 0,
      speed: 3000,
      cssEase: 'linear',
      arrows: false,
      dots: false,
      draggable: false,
      swipe: false,
      touchMove: false,
      pauseOnHover: false,
      pauseOnFocus: false,
      rtl: true,
    });
  }
});


// === WhatsApp FAB ===
const whatsappFab = document.getElementById('whatsappFab');
if (whatsappFab) {
  window.addEventListener('scroll', () => {
    if (window.scrollY > window.innerHeight * 0.5) {
      whatsappFab.style.opacity = '1';
      whatsappFab.style.transform = 'translateY(0)';
    } else {
      whatsappFab.style.opacity = '0';
      whatsappFab.style.transform = 'translateY(16px)';
    }
  }, { passive: true });
}

// === Form ===
const visitForm = document.getElementById('visitForm');
if (visitForm) {
  visitForm.addEventListener('submit', function(e) {
    e.preventDefault();
    const btn = document.getElementById('submitBtn');
    const msg = document.getElementById('formMessage');
    btn.disabled = true;
    btn.innerHTML = '<svg class="w-4 h-4 animate-spin" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg><span>Processing...</span>';
    setTimeout(() => {
      btn.innerHTML = '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg><span>Appointment Confirmed</span>';
      btn.classList.remove('bg-ba'); btn.classList.add('bg-green-600');
      msg.classList.remove('hidden'); msg.classList.add('text-green-400');
      msg.textContent = 'Our team will contact you within 2 hours.';
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = '<span>Confirm Appointment</span><svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17 8l4 4m0 0l-4 4m4-4H3"/></svg>';
        btn.classList.add('bg-ba'); btn.classList.remove('bg-green-600');
        this.reset(); msg.classList.add('hidden');
      }, 4000);
    }, 1800);
  });
}

// === Smooth scroll ===
document.querySelectorAll('a[href^="#"]').forEach(a => {
  if (a.getAttribute('href') === '#') return;
  a.addEventListener('click', function(e) {
    const target = document.querySelector(this.getAttribute('href'));
    if (target) { 
      e.preventDefault(); 
      let offset = 96;
      if(this.getAttribute('href').startsWith('#section-')) offset = 120;
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' }); 
    }
  });
});

// === Category Filter ===
const catBtns = document.querySelectorAll('.cat-btn');
const articleItems = document.querySelectorAll('.article-item');

if (catBtns.length > 0 && articleItems.length > 0) {
  catBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      catBtns.forEach(b => b.classList.remove('cat-active'));
      btn.classList.add('cat-active');

      const cat = btn.dataset.cat;
      articleItems.forEach(item => {
        if (cat === 'all' || item.dataset.cat === cat) {
          item.style.display = '';
          item.style.opacity = '0';
          item.style.transform = 'translateY(20px)';
          requestAnimationFrame(() => {
            item.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
            item.style.opacity = '1';
            item.style.transform = 'translateY(0)';
          });
        } else {
          item.style.opacity = '0';
          item.style.transform = 'translateY(10px)';
          setTimeout(() => { item.style.display = 'none'; }, 300);
        }
      });
    });
  });
}

// === Search ===
const searchInput = document.getElementById('searchInput');
if (searchInput) {
  searchInput.addEventListener('input', (e) => {
    const query = e.target.value.toLowerCase();
    if(catBtns.length > 0) {
      catBtns.forEach(b => b.classList.remove('cat-active'));
      catBtns[0].classList.add('cat-active');
    }

    articleItems.forEach(item => {
      const text = item.textContent.toLowerCase();
      if (query === '' || text.includes(query)) {
        item.style.display = '';
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      } else {
        item.style.opacity = '0';
        setTimeout(() => { item.style.display = 'none'; }, 200);
      }
    });
  });
}

// === Reading Progress Bar ===
const readingProgress = document.getElementById('readingProgress');
if (readingProgress) {
  window.addEventListener('scroll', () => {
    const articleBody = document.querySelector('.article-body');
    if (!articleBody) return;

    const rect = articleBody.getBoundingClientRect();
    const total = articleBody.scrollHeight;
    const visible = window.innerHeight;
    const scrolled = -rect.top;

    if (scrolled <= 0) {
      readingProgress.style.transform = 'scaleX(0)';
    } else if (scrolled >= total - visible) {
      readingProgress.style.transform = 'scaleX(1)';
    } else {
      const progress = scrolled / (total - visible);
      readingProgress.style.transform = `scaleX(${Math.min(1, Math.max(0, progress))})`;
    }
  }, { passive: true });
}

// === Active TOC Link ===
const sections = document.querySelectorAll('[id^="section-"]');
const tocLinks = document.querySelectorAll('.toc-link');

if (sections.length > 0 && tocLinks.length > 0) {
  window.addEventListener('scroll', () => {
    let current = '';
    sections.forEach(section => {
      const rect = section.getBoundingClientRect();
      if (rect.top <= 150) current = section.id;
    });
    tocLinks.forEach(link => {
      if (link.dataset.section === current) {
        link.classList.add('text-ba');
        link.classList.remove('text-bd/50');
        link.style.fontWeight = '500';
      } else {
        link.classList.remove('text-ba');
        link.classList.add('text-bd/50');
        link.style.fontWeight = '300';
      }
    });
  }, { passive: true });
}

// === Newsletter ===
function handleNewsletter(e) {
  e.preventDefault();
  const msg = document.getElementById('nlMessage');
  if (msg) {
    msg.textContent = '✓ SUBSCRIBED SUCCESSFULLY';
    msg.classList.remove('hidden');
    e.target.reset();
    setTimeout(() => msg.classList.add('hidden'), 3000);
  }
}

// Attach newsletter form submit globally
const newsletterForms = document.querySelectorAll('form[onsubmit="handleNewsletter(event)"]');
newsletterForms.forEach(form => {
  form.removeAttribute('onsubmit');
  form.addEventListener('submit', handleNewsletter);
});

// === Copy Link ===
window.copyLink = function() {
  navigator.clipboard.writeText(window.location.href).then(() => {
    const btn = event.currentTarget;
    const original = btn.textContent;
    btn.textContent = 'Copied!';
    btn.classList.add('text-ba', 'border-ba/30');
    setTimeout(() => {
      btn.innerHTML = original;
      btn.classList.remove('text-ba', 'border-ba/30');
    }, 2000);
  });
}

// === Stacking Cards Scroll Effect ===
const initStackingCards = () => {
  const container = document.querySelector('.projects-stack-container');
  const cards = document.querySelectorAll('.project-card');
  if (!container || cards.length === 0) return;

  let cardPositions = []; // Top position of each card relative to the document
  let stickyOffset = 80;   // Matches CSS top: 80px / 120px

  const updateMeasurements = () => {
    stickyOffset = window.innerWidth >= 1024 ? 120 : 80;
    
    // We need to measure the positions of the cards before any transformation is applied!
    cards.forEach(card => {
      const inner = card.querySelector('.project-card-inner');
      if (inner) {
        inner.style.transform = 'none';
        inner.style.setProperty('--card-dim', '0');
      }
    });

    // Calculate original document-relative Y position for each card.
    cardPositions = Array.from(cards).map(card => {
      const rect = card.getBoundingClientRect();
      return rect.top + window.scrollY;
    });
  };

  const handleScroll = () => {
    const scrollY = window.scrollY;

    cards.forEach((card, index) => {
      const inner = card.querySelector('.project-card-inner');
      if (!inner) return;

      // The scroll position where this card starts to stick:
      const triggerY = cardPositions[index] - stickyOffset;

      // How far have we scrolled past the trigger point for this card?
      const scrollPast = scrollY - triggerY;

      if (scrollPast <= 0) {
        // Card is not yet sticky
        inner.style.transform = 'none';
        inner.style.setProperty('--card-dim', '0');
      } else {
        // Card is sticky!
        // We define a scrolling 'range' for the transition based on the next card's offset.
        let range = 600; // default backup range
        if (index < cards.length - 1) {
          range = cardPositions[index + 1] - cardPositions[index];
        } else {
          // Last card: stays at default state
          inner.style.transform = 'none';
          inner.style.setProperty('--card-dim', '0');
          return;
        }

        // Calculate progress (0 to 1+) for scaling this card down.
        const progress = Math.max(0, scrollPast / range);

        // Scale: goes down by 4% per stacking card, capped at 0.85
        const scale = Math.max(0.85, 1 - (progress * 0.04));
        
        // Translate: moves up slightly to create tight deck stacking depth, capped at -40px
        const translateY = Math.max(-40, -progress * 15);

        // Dimming: opacity of the dark overlay, capped at 0.35
        const dim = Math.min(0.35, progress * 0.15);

        inner.style.transform = `scale(${scale}) translateY(${translateY}px)`;
        inner.style.setProperty('--card-dim', dim);
      }
    });
  };

  // Perform initial measurements
  updateMeasurements();

  // Listen to scroll and resize
  let scrollTicking = false;
  window.addEventListener('scroll', () => {
    if (!scrollTicking) {
      window.requestAnimationFrame(() => {
        handleScroll();
        scrollTicking = false;
      });
      scrollTicking = true;
    }
  }, { passive: true });

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateMeasurements();
      handleScroll();
    }, 150);
  });

  // Re-run measurement after page loads to ensure correct positioning of images
  window.addEventListener('load', () => {
    updateMeasurements();
    handleScroll();
  });
  
  // Also run initially
  handleScroll();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStackingCards);
} else {
  initStackingCards();
}

